module.exports = __webpack_public_path__ + "img/6.6c2c6e24.png";